module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P12"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Tables and Figures")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C187"
  }, [_vm._v("TABLES")])]), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction__Obesity_and_the_Ne#id_9"
    }
  }, [_vm._v("I.1. US and world changes in poultry meat production, 1961–2014")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction__Obesity_and_the_Ne#page_13"
    }
  }, [_vm._v("I.2. Concentration ratios (CR4), 2011–2014, by top four firms in food industry markets")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__The_Neoliberal_Food_Regime_an#id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.1. Four-firm concentration (CR4), 2007, by region and product category")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. Total food supply, world, USA, and four emerging nations, 1962–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. Total food supply, world and four nations, as percent of US supply, 1962–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. US average caloric food supply in excess of the world’s average, 1961–2011")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. Changes in main food supply sources in the world and five rich countries, 1961–2011")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. NAFTA partners’ dependency levels in top 80 percent of food supply, 1985 and 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Globalizing_the_Neoliberal_Di#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. Emerging and North American countries’ dependency levels in top five foods, 1985 and 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_7__Food_Security__Obesity__and_I#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1. Ten countries’ cereal and fruit supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_7__Food_Security__Obesity__and_I#id_6",
      "id": "page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2. Ten countries’ rates of change in cereals and fruit supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C189"
  }, [_vm._v("FIGURES")]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__The_Neoliberal_Food_Regime_an#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.1. Food price inflation indices in six countries, 2000–2011")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__The_Neoliberal_Food_Regime_an#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.2. General and food price inflation indices in six countries, 2000–2014")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. US main food caloric sources, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. US average annual household food expenditures, 1984–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. US average per capita food share of total household expenditures, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. US per capita expenditures in food, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5. US food expenditures away from home, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6. US meat consumption, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.7. US per capita fresh fruit expenditures, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.8. US per capita expenditures in fresh vegetables, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.9. US per capita alcohol expenditures, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.10. US per capita expenditures in cereals and cereal products, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.11. US per capita expenditures in bakery products, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.12. US per capita expenditures in fats and oils, 1973–2014, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Mexico-US agricultural trade, 1991–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Canada-US agricultural trade, 1991–2012")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. NAFTA countries’ total food supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4. NAFTA countries’ ratios of total food supply increases or decreases, 1961–2009")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5. NAFTA countries’ beef supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6. NAFTA countries’ poultry meat supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7. NAFTA countries’ vegetable supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.8. NAFTA countries’ fruit supplies, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_25",
      "id": "page_xi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.9. Mexico household food expenditures, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.10. Mexico household food expenditures, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.11. Mexico household fruit expenditures, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.12. Mexico household corn tortilla expenditures, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.13. Mexico household expenditures in sugars, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.14. Mexico household expenditures in fats and oils, 1984–2012, by income quintile")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__NAFTA__Agriculture__and_Work#id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Value index of Mexico’s total food imports excluding fish, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__NAFTA__Agriculture__and_Work#id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Mexico’s agricultural and total merchandise trade, 1961–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__NAFTA__Agriculture__and_Work#id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3. Mexico’s cereal import dependency ratio, 1990–2011")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Globalizing_the_Neoliberal_Di#id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. Cereal import dependency in five countries, 1985–2013")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Globalizing_the_Neoliberal_Di#id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2. Food price indices in seven countries, 2000–2014")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_7__Food_Security__Obesity__and_I#id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1. Vegetable oils as percentage of total food supply in ten countries, 1961–2011")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_7__Food_Security__Obesity__and_I#id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2. Neoliberal diet risk in ten countries, 1985 and 2007")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15aba0c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_LIST_OF_TABLES_AND_FIGURES.vue
// module id = 72
// module chunks = 0